import moment from 'moment';
import React from 'react';
import { useReactToPrint } from 'react-to-print';
import LogoSvg from './logo-svg';
import { getUserFullName } from '../consts';
function ReportHeader({ user, title, isPdf, refToPrint, startDate, endDate, reportGeneratintgTime, timezoneOffset = 999 }) {
    const handlePrint = useReactToPrint({
        content: () => refToPrint.current,
    });
    const isMonthly = title === 'Monthly Report';
    const userFullName = getUserFullName(user);
    const reportCreationTime = reportGeneratintgTime ? moment(reportGeneratintgTime) : moment();
    const generatingDate = timezoneOffset !== 999 ? moment(reportCreationTime).utcOffset(timezoneOffset).format('MMM DD, YYYY - HH:mm A') : moment().format('MMM DD, YYYY - HH:mm A');
    const reportDateKey = `Measurement date${endDate ? 's' : ''}:`;
    const reportDateRange = `${startDate} ${endDate ? `- ${endDate}` : ''} `; //timeZone????
    const css = !isPdf ? {} : {
        header: {
            display: 'none',
        },
        wrapHeader: {
            width: '100%',
            padding: '0',
            margin: '0 10px 5px',
            zIndex: '10',
            backgroundColor: '#fff',
            top: 0,
            left: 0,
            printColorAdjust: 'exact',
            WebkitPrintColorAdjust: 'exact',
        },
        reportHeaderTop: {
            flexWrap: 'nowrap',
            display: 'flex',
        },
        wrapLogo: {
            flexBasis: '24%',
            paddingLeft: '5px',
        },
        infoSection: {
            textAlign: 'start',
            borderLeft: 'solid 1px #efefef',
            paddingLeft: '2%',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginLeft: '2%',
        },
        infoSectionP: {
            margin: 0,
            fontSize: '11px',
        },
        headerCard: {
            color: 'black',
            fontSize: '11px',
            backgroundColor: '#EFEFEF',
            padding: '3px 10px',
            printColorAdjust: 'exact',
            WebkitPrintColorAdjust: 'exact',
        },
        reportHeaderFooter: {
            margin: '0',
            display: 'flex',
            flexWrap: 'nowrap',
        },
        reportHeaderFooterSpan: {
            display: 'flex',
            alignItems: 'center',
        },
        reportDateTitle: {
            color: '#002D66',
            paddingRight: '1rem',
            fontWeight: 400,
        },
        placeDetailes: {
            paddingLeft: '5px',
        },
        reportTitle: {
            flexBasis: '28%',
            color: '#002D66',
            fontSize: '12px',
            fontWeight: 700,
        },
        patientInfo: {
            flexBasis: '72%',
            display: 'flex',
            justifyContent: 'space-between',
        },
        personalDetails: {
            paddingLeft: isMonthly ? '45px' : 0,
            fontSize: '11px',
            color: '#002D66',
            fontWeight: 'bold'
        },
        watchId: {
            margin: 0,
            fontSize: '11px',
            justifyContent: 'flex-end',
            minWidth: 'max-content',
            color: '#449B23',
        },
        reportAction: {
            display: 'none',
        }
    };
    return (React.createElement("div", { style: css.header, id: 'header' },
        React.createElement("div", { className: `wrap-header`, style: css.wrapHeader },
            React.createElement("div", { style: css.reportHeaderTop, className: 'report-header-top' },
                React.createElement("div", { className: 'wrap-logo', style: css.wrapLogo },
                    React.createElement(LogoSvg, { width: isPdf ? 180 : 380, height: isPdf ? 40 : 63 })),
                React.createElement("div", { className: 'info-section size-15', style: css.infoSection },
                    React.createElement("p", { style: Object.assign(Object.assign({}, css.infoSectionP), { flexBasis: endDate ? '100%' : 'auto' }), className: `report-date ${endDate && 'flex-basis-100'}` },
                        React.createElement("span", { style: css.reportDateTitle, className: 'report-date-title' }, reportDateKey),
                        React.createElement("span", { className: 'report-date-value' }, reportDateRange)),
                    endDate && React.createElement("p", { style: css.infoSectionP, className: 'report-generating-date' },
                        React.createElement("span", { style: css.reportDateTitle, className: 'report-date-title' }, "Generating date:"),
                        React.createElement("span", { className: 'report-date-value' }, generatingDate)),
                    React.createElement("p", { style: Object.assign(Object.assign({}, css.infoSectionP), css.placeDetailes), className: 'place-detailes pl-2' }, (user.time_zone || user.time_zone === 0) && `(GMT ${user.time_zone > 0 ? `+ ${user.time_zone}` : `${user.time_zone}`})`))),
            React.createElement("div", { style: Object.assign(Object.assign({}, css.reportHeaderFooter), css.headerCard), className: "row header-card fs-4 report-header-footer" },
                React.createElement("span", { style: Object.assign(Object.assign({}, css.reportHeaderFooterSpan), css.reportTitle), className: 'report-title' }, title),
                React.createElement("div", { style: css.patientInfo, className: 'patient-info' },
                    React.createElement("span", { style: Object.assign(Object.assign({}, css.reportHeaderFooterSpan), css.personalDetails), className: 'personal-details' },
                        userFullName,
                        ", ",
                        user.id_number || user.idNumber),
                    React.createElement("span", { style: Object.assign(Object.assign({}, css.reportHeaderFooterSpan), css.watchId), className: "watch-id green-team" },
                        user.peripheralName || '0000000',
                        React.createElement("div", { style: css.reportAction, className: 'report-actions' },
                            React.createElement("img", { className: 'pointer pl-3', alt: "print", src: require("../assets/icons/print.svg").default, height: "24px", onClick: handlePrint }))))))));
}
export default ReportHeader;
